export function createDebugTable(tableId: string | undefined, eventNumber: number, navigate: Function) {
  fetch("/api/debug-table/" + tableId + "/" + eventNumber, { method: "POST" })
    .then((response) => {
      console.log(response);
      if (response.ok) {
        return response.text();
      }
      return Promise.reject(response);
    })
    .then((url) => {
      navigate("./../" + url);
    });
}
